import { useState, useEffect } from "react";
import { IReview } from "src/domains";
import { queryGetReviewsByService } from "src/graphql";

export const useReviewsByOffer = (offerId?: string) => {
  const [reviews, setReviews] = useState<IReview[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | undefined>();

  useEffect(() => {
    if (offerId) {
      refresh(offerId);
    }
  }, [offerId]);

  const refresh = async (id: string) => {
    setLoading(true);
    setError(undefined);
    try {
      const response = await queryGetReviewsByService(
        {
          serviceId: id,
        },
        "API_KEY"
      );
      setReviews(response?.data.getReviewsByService?.items || []);
    } catch (e) {
      console.error(e);
      setError(e as Error);
    }
    setLoading(false);
  };

  return [reviews, loading, error] as const;
};
